export const INGREDIENTS_EXTRACTOR_SERVICE_HOST = 'https://ingredients-extractor-234667209142.europe-west1.run.app';

export const INGREDIENTS_EXTRACTOR_PATHS = {
  ingredientsProcess: `${INGREDIENTS_EXTRACTOR_SERVICE_HOST}/api/ingredients/process`,
};
